import Brands from "../../components/Brands";

export default function BrandsScreen(){
return <Brands />
}